<template>
  <div class="vx-row">
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
      :collapse-action="true">
      <div class="vx-row">
        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
          <label class="text-sm opacity-100 text-bold">General Search</label>
          <vs-input type="text" v-model="filters['search']" class="w-full mb-4 md:mb-0" />
        </div>
      </div>
      <div class="mt-5 vx-row">
        <div class="w-full ml-auto vx-col">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="filters = {}">CLEAR
          </vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <template slot="actions">
        <div class="flex float-right">
          <div class="con-btns-user flex items-center justify-between">
            <div class="flex mb-4">
              <vs-button v-can="'create-location'" @click="onClickCreateLocation" class="mr-4" color="primary"
                type="filled">New</vs-button>
            </div>
          </div>
        </div>
      </template>
      <div slot="no-body" class="mt-4">

        <vs-table :max-items="(meta.pageSize) ? meta.pageSize : 10" id="users-list" :data="users_list"
          @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

          <template slot="thead">
            <vs-th width="10%">Code</vs-th>
            <vs-th width="10%" v-if="!id">Company</vs-th>
            <vs-th width="10%">Name</vs-th>
            <vs-th width="10%">State</vs-th>
            <vs-th width="10%">Country</vs-th>
            <vs-th width="10%">Location Type</vs-th>
            <vs-th width="10%" v-can="'update-location'"></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr class="cursor-pointer" @click.native="onClickUpdate(data[indextr])" :key="indextr" v-for="(tr, indextr) in data">


              <vs-td :data="data[indextr].Code">
                {{ data[indextr].Code }}
              </vs-td>

              <vs-td v-if="!id">
                <span v-if="!!data[indextr].Company" @click.stop="onClickOpenCompany(data[indextr].Company._id)" class="cursor-pointer underline">
                  {{ data[indextr].Company.Name }}
                </span>
              </vs-td>

              <vs-td :data="data[indextr].Name">
                {{ data[indextr].Name }}
              </vs-td>
              
              <vs-td :data="data[indextr].Location_State">
                {{ data[indextr].State || '' }}
              </vs-td>

              <vs-td :data="data[indextr].Location_Type">
                {{ data[indextr].Country || '' }}
              </vs-td>

              <vs-td :data="data[indextr].Location_Type">
                {{ data[indextr].LocationType || '' }}
              </vs-td>

              <vs-td>
                <div class="vx-row">
                  <vx-tooltip v-can="'update-location'" class="mr-2" text="Update/View Location" position="top">
                    <vs-button @click.stop="onClickUpdate(data[indextr])" size="small" color="primary" type="border"
                      icon-pack="feather" icon="icon-eye"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-can="'delete-location'" class="mr-2" text="Delete Location" position="top">
                    <vs-button @click.stop="onClickDeleteConfirm(data[indextr]._id)" size="small" color="danger" type="border"
                      icon-pack="feather" icon="icon-trash-2"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>

        </vs-table>
        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.pageSize ? meta.pageSize : 20"
          :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
          description :description-items="descriptionItems" :total="(meta.totalPages) ? meta.totalPages : 0"
          v-model="page" class="p-5">
        </vs-pagination>
      </div>
    </vx-card>
    <CreateObjectPopUp ref="createObjectPopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const UserRepository = RepositoryFactory.get('user')
const TenantRepository = RepositoryFactory.get('tenant')
const ObjectRepository = RepositoryFactory.get('object')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateObjectPopUp from "@/components/popups/general/CreateObjectPopUp.vue"
import { defaultPagination, perPageList } from "@/constants/config";

export default {
  name: 'TenantLocations',
  data() {
    return {
      users_list: [],
      id: '',
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      object_name: 'location'
    }
  },
  async mounted() {
    this.id = this.$route.params.id
    if (this.$route.query.open) {
      await this.$refs.createObjectPopUp.openPopup(this.object_name, 'update', { _id: this.$route.query.open })
    }
  },
  components: {
    CreateObjectPopUp
  },
  methods: {
    async refreshData() {
      await this.fetchUsersList()
    },
    async fetchUsersList() {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = (await TenantRepository.getLocationList(this.page, this.filterQuery, this.perPage, this.sort, this.id)).data
        this.users_list = data.data
        this.meta = data.pagination
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickCreateLocation() {
      await this.$refs.createObjectPopUp.openPopup(this.object_name, 'create', this.id ? { Company: this.id, OwnerId: this.$store.getters.currentUserId } : {})
    },
    async onClickUpdate(data) {
      await this.$refs.createObjectPopUp.openPopup(this.object_name, 'update', data)
    },
    async onClickResendEmail(email) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = await TenantRepository.resendTenantStaffUserWelcomeEmail(this.id, email)
        this.showSuccessMessage('Staff user welcome email send successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickDeleteConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        acceptText: 'Delete',
        text: `Are you sure you want to delete this location?`,
        accept: this.onClickDelete,
        parameters: [ id ]
      })
    },
    async onClickDelete(params) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        await ObjectRepository.deleteObject(this.object_name, params[0])
        this.fetchUsersList()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    filterQueryUpdate() {
      this.fetchUsersList()
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchUsersList()
      }
    },
    onClickOpenCompany(id) {
      const route = this.$router.resolve({ path: `/pages/companies/${id}` });
      window.open(route.href, '_blank');
    },
  },
  watch: {
    page() {
      this.fetchUsersList()
    },
    perPage() {
      this.fetchUsersList()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped></style>
